export enum FormType {
	CONFIRM_FORGOT_PASSWORD = 'ConfirmForgotPassword',
	CHANGE_PASSWORD = 'ChangePassword',
}
